module.exports = __webpack_public_path__ + "static/NE-24d14e6908fe26270d1a16e7f48ec686.svg";